import React from "react";
import {
    // Dialog,
    // DialogContent,
    Typography,
    Button,
    // IconButton,
} from "@mui/material";
import BedtimeIcon from "@mui/icons-material/Bedtime";
import WbSunnyIcon from "@mui/icons-material/WbSunny";

const MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

function formatDateTime(dateStr, timeStr) {
    if (!dateStr || !timeStr) return "";
    const [h = 0, m = 0, s = 0] = timeStr.split(":").map(Number);
    const d = new Date(dateStr);
    d.setHours(h, m, s, 0);
    const hours = d.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    const h12 = hours % 12 || 12;
    const timePart = `${String(h12).padStart(2, "0")}.${String(d.getMinutes()).padStart(2, "0")}.${String(d.getSeconds()).padStart(2, "0")} ${ampm}`;
    const datePart = `${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
    return `${timePart} ${datePart}`;
}

function splitTimeAndDate(value) {
    if (!value) return { timePart: "", datePart: "" };
    const match = value.match(/^(.*?\b(?:AM|PM))\s+(.*)$/);
    if (!match) return { timePart: value, datePart: "" };
    return { timePart: match[1], datePart: match[2] };
}

const DUMMY_DEVICE = "OxiWear Device";
const DUMMY_START = "10.16.25 PM Dec 28, 2025";
const DUMMY_END = "07.08.04 AM Dec 29, 2025";

const cardStyle = {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
    flexWrap: "wrap",
    justifyContent: "center",
    padding: "20px 24px",
};
const timeColumnStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "12px",
    minWidth: "220px",
};
const iconCircleStyle = {
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: "#444444",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};
const timeColumnTextStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
};
const labelStyle = {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500,
    color: "#444444",
    marginBottom: "4px",
};
const valueBoldStyle = {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 700,
    color: "#333333",
    lineHeight: 1.4,
};
const valueRegularStyle = {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 400,
    color: "#333333",
    lineHeight: 1.4,
};

export default function VerifiedSleepData({
    formData,
    setShowVerifiedSleepData,
    onNextStep,
    setAlertDetails,
}) {
    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2rem",
                    height: "100%",
                    marginTop: "12px",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "12px",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "8px",
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontSize: "14px",
                                fontWeight: 500,
                                color: "#444",
                                minWidth: "100px",
                            }}
                        >
                            Device
                        </Typography>
                        <Typography style={valueBoldStyle}>
                            {formData?.deviceLabel
                                ? formData.deviceLabel
                                : formData?.device
                                  ? formData.device
                                  : DUMMY_DEVICE}
                        </Typography>
                    </div>
                    <div
                        style={{
                            ...cardStyle,
                            flexDirection: "column",
                            alignSelf: "flex-start",
                            width: "fit-content",
                        }}
                    >
                        <div style={timeColumnStyle}>
                            <div style={iconCircleStyle}>
                                <BedtimeIcon sx={{ fontSize: 22 }} />
                            </div>
                            <div style={timeColumnTextStyle}>
                                <Typography style={labelStyle}>
                                    Start Time
                                </Typography>
                                <Typography style={valueRegularStyle}>
                                    {(() => {
                                        const displayValue =
                                            formData?.startDate &&
                                            formData?.startTime
                                                ? formatDateTime(
                                                      formData.startDate,
                                                      formData.startTime,
                                                  )
                                                : DUMMY_START;
                                        const { timePart, datePart } =
                                            splitTimeAndDate(displayValue);
                                        return (
                                            <>
                                                <span
                                                    style={{
                                                        ...valueBoldStyle,
                                                        display: "inline",
                                                    }}
                                                >
                                                    {timePart}
                                                </span>
                                                {datePart ? ` ${datePart}` : ""}
                                            </>
                                        );
                                    })()}
                                </Typography>
                            </div>
                        </div>
                        <div
                            style={{
                                width: "100%",
                                height: "1px",
                            }}
                        />
                        <div style={timeColumnStyle}>
                            <div style={iconCircleStyle}>
                                <WbSunnyIcon sx={{ fontSize: 22 }} />
                            </div>
                            <div style={timeColumnTextStyle}>
                                <Typography style={labelStyle}>
                                    End Time
                                </Typography>
                                <Typography style={valueRegularStyle}>
                                    {(() => {
                                        const displayValue =
                                            formData?.endDate &&
                                            formData?.endTime
                                                ? formatDateTime(
                                                      formData.endDate,
                                                      formData.endTime,
                                                  )
                                                : DUMMY_END;
                                        const { timePart, datePart } =
                                            splitTimeAndDate(displayValue);
                                        return (
                                            <>
                                                <span
                                                    style={{
                                                        ...valueBoldStyle,
                                                        display: "inline",
                                                    }}
                                                >
                                                    {timePart}
                                                </span>
                                                {datePart ? ` ${datePart}` : ""}
                                            </>
                                        );
                                    })()}
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: "auto" }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "12px",
                            marginTop: "5rem",
                            paddingTop: "24px",
                        }}
                    >
                        <Button
                            onClick={() => {
                                setShowVerifiedSleepData(false);
                                setAlertDetails?.({
                                    message: "",
                                    severity: "error",
                                    showAlert: false,
                                });
                            }}
                            variant="outlined"
                            style={{
                                color: "#0F9BB0",
                                padding: "8px 24px",
                                border: "1px solid #0F9BB0",
                                borderRadius: "4px",
                                textTransform: "none",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                width: "196px",
                                height: "48px",
                            }}
                        >
                            Edit
                        </Button>
                        <Button
                            onClick={() => {
                                onNextStep?.(formData);
                                setAlertDetails?.({
                                    message: "",
                                    severity: "error",
                                    showAlert: false,
                                });
                            }}
                            variant="contained"
                            style={{
                                backgroundColor: "#0F9BB0",
                                color: "white",
                                padding: "8px 24px",
                                border: "1px solid #0F9BB0",
                                borderRadius: "4px",
                                textTransform: "none",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                width: "196px",
                                height: "48px",
                            }}
                        >
                            Next
                        </Button>
                    </div>
                    <div
                        style={{
                            marginTop: "0px",
                            display: "flex",
                            justifyContent: "flex-end",
                            width: "100%",
                            fontFamily: "Poppins",
                        }}
                    >
                        <p>Click Next to fill other information.</p>
                    </div>
                </div>
            </div>
        </>
    );
}
